import * as types from '../constants/ActionTypes';
import update from 'immutability-helper';

const initialState = {  
    EventsList: [],
    locationCode: 0,
    eventTypeId: 0,
    maxEventsSize: null,
    date: null
};

export default function searchEvents (state = initialState, action) {
    switch (action.type) {
        case types.SET_EVENTS_LOCATION_CODE:
            return update(state, {locationCode: {$set: action.locationCode} })
        case types.SET_EVENTS_EVENTTYPE_ID:
            return update(state, {eventTypeId: {$set: action.eventTypeId} })
        case types.SET_EVENTS_MAXEVENTS_SIZE:
            return update(state, {maxEventsSize: {$set: action.maxEventsSize} })
        case types.SET_EVENTS_DATE:
            return update(state, {date: {$set: action.date} })
        case types.SET_EVENTS_LIST:
            return update(state, {EventsList: {$set: action.eventsList} })
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_allevents.js